import { gsap, Power1, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin);


$('.js-go-top').click(()=> {
	gsap.to(window, {duration: 1, scrollTo: 0});
})








